/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageResponseDtoAttachmentsInner } from './MessageResponseDtoAttachmentsInner';
import {
    MessageResponseDtoAttachmentsInnerFromJSON,
    MessageResponseDtoAttachmentsInnerFromJSONTyped,
    MessageResponseDtoAttachmentsInnerToJSON,
    MessageResponseDtoAttachmentsInnerToJSONTyped,
} from './MessageResponseDtoAttachmentsInner';

/**
 * 
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
    /**
     * Unique message ID
     * @type {string}
     * @memberof MessageResponseDto
     */
    id: string;
    /**
     * Message role
     * @type {string}
     * @memberof MessageResponseDto
     */
    role: MessageResponseDtoRoleEnum;
    /**
     * Message content
     * @type {string}
     * @memberof MessageResponseDto
     */
    content: string;
    /**
     * File attachments
     * @type {Array<MessageResponseDtoAttachmentsInner>}
     * @memberof MessageResponseDto
     */
    attachments?: Array<MessageResponseDtoAttachmentsInner>;
    /**
     * When the message was created
     * @type {Date}
     * @memberof MessageResponseDto
     */
    createdAt: Date;
}


/**
 * @export
 */
export const MessageResponseDtoRoleEnum = {
    User: 'user',
    Model: 'model'
} as const;
export type MessageResponseDtoRoleEnum = typeof MessageResponseDtoRoleEnum[keyof typeof MessageResponseDtoRoleEnum];


/**
 * Check if a given object implements the MessageResponseDto interface.
 */
export function instanceOfMessageResponseDto(value: object): value is MessageResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function MessageResponseDtoFromJSON(json: any): MessageResponseDto {
    return MessageResponseDtoFromJSONTyped(json, false);
}

export function MessageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'role': json['role'],
        'content': json['content'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(MessageResponseDtoAttachmentsInnerFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function MessageResponseDtoToJSON(json: any): MessageResponseDto {
    return MessageResponseDtoToJSONTyped(json, false);
}

export function MessageResponseDtoToJSONTyped(value?: MessageResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'role': value['role'],
        'content': value['content'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(MessageResponseDtoAttachmentsInnerToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

